import styled, { css, up } from "@xstyled/styled-components";

import { Button, Card, Spacing, Text } from "@otta/design";
import { palette, pxToRem } from "@otta/design-tokens";
import { Icon } from "@otta/icons";

const RedCircle = styled.div`
  background-color: red-600;
  width: 4rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  margin: 0 auto;
`;

const ErrorContainer = styled.div`
  width: 100%;
  max-width: ${pxToRem(440)};
  margin: 0 auto;
  text-align: center;
  padding: lg 6;

  ${up(
    "tablet",
    css`
      padding: lg;
    `
  )}
`;

export function Error({
  title = "Something went wrong",
  body = "Check your internet connection and try again.",
  cta = "Try again",
  action,
}: {
  title?: string;
  body?: string;
  cta?: string;
  action: () => void;
}) {
  return (
    <ErrorContainer>
      <Card>
        <Spacing size={2}>
          <RedCircle>
            <Icon
              icon="circle-exclamation"
              style={{ color: palette.brand.white }}
              size={4.5}
            />
          </RedCircle>
          <Spacing size={-1}>
            <Text size={1} bold>
              {title}
            </Text>
            <Text>{body}</Text>
          </Spacing>
          <Button level="primary" onClick={() => action()}>
            {cta}
          </Button>
        </Spacing>
      </Card>
    </ErrorContainer>
  );
}
